import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { allCompanies } from "../../../data/Axios/queries";
import { setupManagementUrl } from "../../../config";
import {
  executeDynamicSubmit,
  executeAnyMutation,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;

const TransactionTypeForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const initialValues = {
    name: props.data ? props.data.Name : "",
    description: props.data ? props.data.Description : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name required"),
    description: yup.string().required("Description required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const { name, description } = values;
    const variables = props.isEditing
      ? { id: props.data.Id, name, description, createdBy: userId }
      : { name, description, createdBy: userId };

    await executeDynamicSubmit({
      mutationName: props.isEditing
        ? "updateTransactionType"
        : "createTransactionType",
      variables,
      mutationObjectName: "transactionType",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Transaction Type",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={
          props.isEditing ? "Edit Transaction Type" : "Create Transaction Type"
        }
        subtitle={
          props.isEditing
            ? "Edit an Existing Transaction Type"
            : "Create a New Transaction Type"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Transaction Type Name*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default TransactionTypeForm;
